import { useEffect, useState, ReactNode } from 'react';
import { DarkModeContext } from './useDarkMode';

export function DarkModeProvider({ children }: { children: ReactNode }) {
  // Initialize dark mode from localStorage or default to true (dark)
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem('darkMode');
      return stored === null ? true : stored === 'true';
    } catch (error) {
      console.warn('localStorage access failed, defaulting to dark mode:', error);
      return true; // Default to dark mode if localStorage fails
    }
  });

  useEffect(() => {
    try {
      // Update the document class and localStorage
      const root = document.documentElement;
      if (isDarkMode) {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
      localStorage.setItem('darkMode', isDarkMode.toString());
    } catch (error) {
      console.warn('localStorage write failed:', error);
      // Continue without persisting - app still functions
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}
